import PatternGrid, { SupportedTileSize } from './PatternGrid';

export type Pattern = SupportedTileSize[];

export default PatternGrid;

export { default as PatternGridGhost } from './PatternGridGhost';
